import oRequest from "@/libsV2/request.js";

const URL = {
  SERVICE_EARTH_SCORE: "hvac/score/title", //全国冷暖风服务评分
  SERVICE_EARTH_NUM: "hvac/score/total", //全国项目总睡,服务商总数
  SERVICE_EARTH_PERCENTAGE: "hvac/score/scores", //全国项目服务和满意度柱形图
  SERVICE_EARTH_MONTH: "hvac/score/lines", //折线图月度评分
  SERVICE_EARTH_RANK: "hvac/score/rank", //折线图月度评分
  SERVICE_QUESTION_CIRCE: "hvac/score/plist", //高频问题环形图数据
  SERVICE_QUESTION_TYPE: "hvac/score/services", //高频问题问题类型
  SERVICE_QUESTION_MODULAR: "hvac/score/cates", //高频问题根据问题类型获取问题模块
  SERVICE_QUESTION_LIST: "hvac/score/wrongs", //高频问题根据问题模块获取问题详细列表
  SERVICE_TEAM: "member/project/team", //项目团队人员
  SERVICE_PROJECT_DETAIL: "hvac/score/items", //服务商项目明细
  SERVICE_AREA: "hvac/score/areas", //大区下拉接口
  SERVICE_PROVIDER: "hvac/score/companys", //服务商下拉接口
  SERVICE_CITY: "hvac/score/citys", //城市下拉接口
  SERVICE_TIME: "hvac/score/times", //有数据的时间
};

export const getEarthScore = (data = {}) => {
  return oRequest.getData(URL.SERVICE_EARTH_SCORE, data);
};
export const getEarthTotal = (data = {}) => {
  return oRequest.getData(URL.SERVICE_EARTH_NUM, data);
};
export const getEarthPercentage = (data = {}) => {
  return oRequest.getData(URL.SERVICE_EARTH_PERCENTAGE, data);
};
export const getEarthMonth = (data = {}) => {
  return oRequest.getData(URL.SERVICE_EARTH_MONTH, data);
};
export const getEarthRank = (data = {}) => {
  return oRequest.getData(URL.SERVICE_EARTH_RANK, data);
};
export const getQuestionCirce = (data = {}) => {
  return oRequest.getData(URL.SERVICE_QUESTION_CIRCE, data);
};
export const getQuestionType = (data = {}) => {
  return oRequest.getData(URL.SERVICE_QUESTION_TYPE, data);
};
export const getQuestionModular = (data = {}) => {
  return oRequest.getData(URL.SERVICE_QUESTION_MODULAR, data);
};
export const getQuestionList = (data = {}) => {
  return oRequest.getData(URL.SERVICE_QUESTION_LIST, data);
};
export const getTeamPerson = (data = {}) => {
  return oRequest.getData(URL.SERVICE_TEAM, data);
};
export const getProjectDetail = (data = {}) => {
  return oRequest.getData(URL.SERVICE_PROJECT_DETAIL, data);
};
export const getArea = (data = {}) => {
  return oRequest.getData(URL.SERVICE_AREA, data);
};
export const getProvider = (data = {}) => {
  return oRequest.getData(URL.SERVICE_PROVIDER, data);
};
export const getCity = (data = {}) => {
  return oRequest.getData(URL.SERVICE_CITY, data);
};
export const getTimeDate = (data = {}) => {
  return oRequest.getData(URL.SERVICE_TIME, data);
};